import { FilterProps } from '../filter-container';
import { useTranslation } from 'react-i18next';
import { isValidAccountHash } from '../../../utils/account';
import React from 'react';
import { InputFilter } from './input-filter';

export const ContractPackageHashFilter = (
  props: FilterProps & { isFullView?: boolean }
) => {
  const { t } = useTranslation();

  const handleValidateInput = (inputValue: string | null) => {
    if (!inputValue) return null;
    if (!isValidAccountHash(inputValue)) {
      return t('Value is incorrect');
    }

    return null;
  };

  return (
    <InputFilter
      filterId={'contract_package_hash'}
      label={t('Filter by contract')}
      rightLabel={t('Paste hash')}
      placeholder={t('Contract Package Hash')}
      handleValidateInput={handleValidateInput}
      {...props}
    />
  );
};
